import styled from 'styled-components'

// FS-internal sticky footer — NOT a feature: it renders pure cross-feature
// math from both panes' selections and the session/matches figures
// (BHV-031/032/036).
export const FooterBarStyled = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: ${({ theme }) => theme.zIndex.navigation};
  padding: ${({ theme }) => `${theme.space.medium} ${theme.space.xlarge}`};
  background: ${({ theme }) => theme.colors.white};
  border-top: 1px solid ${({ theme }) => theme.colors.content.border};
`
